import { OperacoesWebAPI } from '../../utils/global';
import api from '../api'

export const tipoDocumentoService = {
    post: (tipoDocumento: any) => {
        return api.post(`${OperacoesWebAPI.TipoDocumento}`, tipoDocumento).then((resp) => { return resp.data })
    },
    put: (tipoDocumento: any) => {
        return api.put(`${OperacoesWebAPI.TipoDocumento}`, tipoDocumento)
    },
    get: () => {
        return api.get(`${OperacoesWebAPI.TipoDocumento}`)
    },

    delete: (tipoDocumentoID: number) => {
        return api.delete(`${OperacoesWebAPI.TipoDocumento}?id=${tipoDocumentoID}`)
    }
}